import { render, staticRenderFns } from "./DelegateList.vue?vue&type=template&id=e9d1c548&"
import script from "./DelegateList.vue?vue&type=script&lang=js&"
export * from "./DelegateList.vue?vue&type=script&lang=js&"
import style0 from "./DelegateList.vue?vue&type=style&index=0&id=e9d1c548&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports